import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useAppTransitionState, AppTransitionState } from '../utils';
import { messageFactory, Topic, useAuthStateStore, } from '@annunciate/core';
export const useAppTransitionListener = () => {
    const state = useAppTransitionState();
    const client = useQueryClient();
    useEffect(() => {
        if (state === AppTransitionState.TO_FOREGROUND) {
            if (useAuthStateStore.getState().getUUID() !== undefined) {
                client.invalidateQueries({
                    queryKey: ['user'],
                    exact: false,
                    type: 'all',
                });
            }
            messageFactory(Topic.APP_FOREGROUNDED);
        }
        else if (state === AppTransitionState.TO_BACKGROUND) {
            messageFactory(Topic.APP_BACKGROUNDED);
        }
    }, [state]);
};
//# sourceMappingURL=useAppTransitionListener.js.map